import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchOverlay from "@/components/feature/SearchOverlay";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影视理论", to: "/category/theory" },
  { label: "电影评论", to: "/category/review" },
  { label: "影视文化与研究", to: "/category/culture" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative text-sm font-medium transition-colors whitespace-nowrap py-2 ${
      isActive
        ? "text-primary-700"
        : "text-foreground-600 hover:text-primary-700"
    }`;

  return (
    <>
      <header
        className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200"
            : "bg-background-50 border-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-8 flex items-center h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 mr-6 md:mr-12">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-wide">
                理论电影
              </span>
              <span className="hidden sm:block text-[10px] tracking-[0.25em] text-foreground-400 mt-0.5">
                FILM THEORY
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-1.5">
            <button
              onClick={() => setSearchOpen(true)}
              aria-label="打开搜索"
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-600 hover:bg-background-100 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-xl" />
            </button>
            <Link
              to="/contact"
              className="hidden md:inline-flex items-center px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors"
            >
              联系我们
            </Link>
            <button
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
            <nav className="px-4 py-3 flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-2 py-3 text-sm font-medium border-b border-background-100 last:border-0 ${
                      isActive ? "text-primary-700" : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                className="mt-3 mb-2 inline-flex items-center justify-center px-4 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap"
              >
                联系我们
              </Link>
            </nav>
          </div>
        )}
      </header>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}